/**
 * Product Types
 *
 * GET_LIST
 */
export const RESOURCES = {
    "ProductTypes": {
        GET_LIST: function (params) {
            const system = encodeURIComponent(localStorage.getItem('system'));
            return {
                "type": "list",
                "method": "GET",
                "title": "Locations",
                "uri": localStorage.getItem('server') + "/api/v5/report/productType/" + system + "/getAll"
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "ProductTypes"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseProductsResourceMap.js